import React, { Component } from "react";
import LocationMap from "./LocationMap";
import { portalService } from "../../../services";
import NoLocationFound from "../../../../../assets/images/sad_face.png";

export default class LocationListItem extends Component {
  componentDidMount = async () => {
    const { location, onPositionLoad } = this.props;
    if (!location.position) {
      const { data } = await portalService.getLocationPosition(location);
      if (data != null) {
        const { lat, lng } = data;
        onPositionLoad(location.locationId, {
          lat,
          lng
        });
      }
    }
  };

  getFullAddress = location => {
    return `${location.streetAddress}, ${location.suburb} ${
      location.postcode
    }, ${location.country}`;
  };

  render() {
    const { selected, location, onClick } = this.props;
    return (
      <div
        onClick={() => onClick(location)}
        className={`drawer-card ${selected ? "selected" : ""}`}
      >
        <div className="location-card">
          <div className="media">
            <div className="google-map-overlay" />
            {location.position ? (
              <LocationMap
                zoom={15}
                position={location.position}
                containerElement={<div className="google-map-container" />}
              />
            ) : (
              <img src={NoLocationFound} alt={location.name} />
            )}
          </div>
          <div className="information-panel">
            <span className="info-title">{location.name}</span>
            <span className="info-desc">{`${location.streetAddress} ${
              location.suburb
            } ${location.state}, ${location.postcode}`}</span>
          </div>
        </div>
        {selected ? (
          <i className={`material-icons ${selected ? "selected-icon" : ""}`}>
            done
          </i>
        ) : null}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/BookingPortal/components/Steps/DrawerContent/LocationListItem.js